import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './loader.module.css';
/**
 * `<Loader/>` - Компонент, отображающий статус загрузки в интерфейсе.
 *
 * @example```tsx
 * <Loader size="m" />`
 * ```
 */
export const Loader = ({
  size = 'l',
  variant = 'primary',
  className,
  'data-testid': testId = 'loader'
}) => {
  const wrapperClassName = useMemo(() => clsx(styles.loader, styles[variant], styles[size], className), [className, size, variant]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    role: "presentation",
    "data-testid": testId
  }, /*#__PURE__*/React.createElement("svg", {
    className: styles.circular,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: styles.path,
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    strokeMiterlimit: "10"
  })));
};